<template>
  <v-list-item
    v-if="canViewVerticalNavMenuLink(item)"
    v-bind="linkProps"
    :class="{'bg-gradient-primary white--text': isActive}"
    :ripple="false"
    class="vertical-nav-menu-link"
    active-class="bg-gradient-primary"
  >
    <v-list-item-icon>
      <v-icon
        :class="{'alternate-icon-small': !item.icon}"
        :color="isActive ? 'white': null"
      >
        {{ item.icon || alternateIcon }}
      </v-icon>
    </v-list-item-icon>

    <v-list-item-title :class="{'white--text': isActive}">
      {{ item.title }}
    </v-list-item-title>
    <v-list-item-action
      v-if="dynamicBadge"
      class="flex-shrink-0"
    >
      <v-badge
        :color="dynamicBadgeColor"
        inline
        :content="dynamicBadge"
      >
      </v-badge>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { computed, getCurrentInstance } from '@vue/composition-api'
import themeConfig from '@themeConfig'
import { useUtils as useAclUtils } from '@core/libs/acl'
import useVerticalNavLink from '@core/layouts/composable/vertical-nav/useVerticalNavLink'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy
    const { isActive, linkProps } = useVerticalNavLink(props.item)
    const { canViewVerticalNavMenuLink } = useAclUtils()

    // オーダーメニューの動的バッジ対応
    const dynamicBadge = computed(() => {
      // 静的に設定されたバッジがあればそれを使用
      if (props.item.badge) {
        return props.item.badge
      }

      // オーダーメニューの場合、Vuexから未読数を取得
      if (props.item.to?.name === 'waiter-orders') {
        const unreadCount = vm.$store?.state?.selfOrder?.unreadOrderCount || 0

        return unreadCount > 0 ? unreadCount : null
      }

      return null
    })

    const dynamicBadgeColor = computed(() => {
      if (props.item.badgeColor) {
        return props.item.badgeColor
      }

      // オーダーメニューのバッジはゴールド色
      if (props.item.to?.name === 'waiter-orders') {
        return '#d4bc83'
      }

      return 'primary'
    })

    return {
      isActive,
      linkProps,
      alternateIcon: themeConfig.menu.groupChildIcon,
      dynamicBadge,
      dynamicBadgeColor,

      // ACL
      canViewVerticalNavMenuLink,
    }
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.vertical-nav-menu-link {
  &.v-list-item--active {
    box-shadow: 0 5px 10px -4px rgba(94, 86, 105, 0.42);
    @include elevationTransition();
  }

  .v-badge__badge {
    color: #3a2e1a !important;
  }
}
</style>
